import { Info } from 'lucide-react'

import { Zone } from '@/core/api/entities/zone/zone'
import { Checkbox } from '@/shared/components/atoms/Checkbox'
import { cn } from '@/shared/utils/helpers'

interface ZoneRowProps {
	zone: Zone
	isSelected: boolean
	onSelectionChange: (checked: boolean) => void
	className?: string
	showAddress?: boolean
	disabled?: boolean
	disabledReason?: string
}

export function ZoneRow({
	zone,

	isSelected,
	onSelectionChange,
	className,
	showAddress = true,
	disabled = false,
	disabledReason,
}: ZoneRowProps) {
	const handleRowClick = () => {
		if (!disabled) {
			onSelectionChange(!isSelected)
		}
	}

	// Build location text for address display
	const locationText = zone.location
		? `${zone.location.name}${zone.location.country ? ` (${zone.location.country})` : ''}`
		: null

	const hasLocation = !!locationText

	const rowContent = (
		<div
			className={cn(
				'flex items-center justify-between px-4 py-4',
				disabled
					? 'opacity-50 cursor-not-allowed'
					: 'hover:bg-accent/50 cursor-pointer',
				className
			)}
			onClick={handleRowClick}
		>
			<div className="flex-1 pr-4 flex flex-col justify-center">
				<p
					className={`text-sm font-medium ${(showAddress && hasLocation) || (disabled && disabledReason) ? 'mb-1' : ''}`}
				>
					{zone.name}
				</p>

				<p className="text-xs text-muted-foreground">
					ID: {zone.id}
					{showAddress && hasLocation && ` • ${locationText}`}
				</p>

				{disabled && disabledReason && (
					<p className="text-xs text-[color:var(--status-warning)] mt-1 flex items-center gap-1">
						<Info className="h-3 w-3 flex-shrink-0" />
						<span>{disabledReason}</span>
					</p>
				)}
			</div>
			<Checkbox
				checked={isSelected}
				onCheckedChange={(checked) => onSelectionChange(checked === true)}
				onClick={(e) => e.stopPropagation()}
				disabled={disabled}
			/>
		</div>
	)

	return rowContent
}
